import app from 'app';
import defaultState from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { getStageDimensions, getThemeInfo } from './assetEditorApi.js';
import { checkIfPreviewNeeded } from './assetEditorApi.js';

/** (GW)
 * Asset Editor's Store
 */
export default class AssetEditorStore {
  constructor(_state, { storyModel, asset }) {
    const state = _.merge(_.cloneDeep(defaultState), _state);

    // related to current story
    state.story = {
      id: storyModel.get('id'),
      aspectRatio: storyModel.get('_aspectRatio'),
      showVolumeDualSettings:
        app.rootStore.getters['timemachine/shouldShow_TrackLayerAudio'],
      programmer: storyModel.getProgrammer().toJSON(),
      textStyles: storyModel.get('_textStyles') || [],
      bgMusic: app.rootStore.state.story.storyBackgroundMusic,
    };
    state.defaultVolumePresets = app.getVolumeSettings(storyModel);
    state.selectedTransitionPreset = storyModel.get(
      'transitionSelection'
    ).selectedPreset;
    state.stageDimensions = getStageDimensions(storyModel);
    state.isStoryboard = !!storyModel.get('template');
    state.allThemeInfos = storyModel.get('_themeInfo');
    state.themeInfo = getThemeInfo(storyModel);

    // related to current asset
    mutations.setCurrentAsset(state, { asset });
    checkIfPreviewNeeded(state);
    mutations.setIanContext(state, { asset: state.workModel });

    this.namespaced = true;
    this.state = state;
    this.getters = Object.assign({}, getters);
    this.mutations = Object.assign({}, mutations);
    this.actions = Object.assign({}, actions);
  }
}
